import styles from './Congrats.module.css'

export function Congrats() {
  return <div className={styles.congrats}>Congrats 🎉</div>
}
